import { plugin, debug } from 'light-component';
import { Radio } from 'antd';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ComboboxProps } from './types';

export function WidgetCombobox(props: ComboboxProps): ReactElement {
  debug.widget('form combobox', props);

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div>
        <Radio.Group className={styles.antRadioButtonCustom} disabled={props.disabled} value={props.value} buttonStyle='solid'>
          {
            props.options.map(option => (
              <Radio.Button
                key={option.value}
                value={option.value}
                onChange={() => props?.onChange?.(option.value, props)}>
                {t(option.title)}
              </Radio.Button>
            ))
          }
        </Radio.Group>
      </div>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'combobox', component: WidgetCombobox });
